module.exports = "query getCategoryProducts($handles:[String]){entries(section:\"products\",slug:$handles){slug hidden}}"